<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-row>
        <v-col>
          <span class="headline">
            {{ $t('scaleDataDetails') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <BaseDialogActions hideFullscreen hideRefresh />
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="pt-6 pb-8">
      <v-row v-for="([key, value]) in Object.entries(detailItems)" :key="key">
        <v-col cols="auto">
          <Icon v-if="key !== 'scaleDataSource'" margin="" iconColor="rgba(0,0,0,0.6)" :icon="IconHelpers.getIconForObjectType(key)" :small="false"/>
          <Icon v-else margin="" iconColor="rgba(0,0,0,0.6)" :icon="getScaleDataSourceIcon(scaleDataSource)" :small="false"/>
        </v-col>
        <v-col cols="auto" :style="{ width: '150px' }">
          <span v-if="key === 'scaleDataSource'">{{ $t('source') }}:</span>
          <span v-else>{{ $t(key) }}:</span>
        </v-col>
        <v-col>
          <span v-if="key === 'scaleDataSource'">{{ getScaleDataSourceTooltip(scaleDataSource) }}</span>
          <span v-else>{{ value }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatScaleDataInfo } from '@/components/ticket/ticket-details/scale-data/TicketScaleData'
import IconHelpers from '@/utils/IconHelpers'
import { ScaleDataSource } from '@/utils/Enumerations'

export default {
  name: 'TicketScaleDataInfoCard',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    scaleData: {
      type: Object,
      required: true
    },
    scaleDataSource: {
      type: Number,
      required: false,
      default: null
    },
    ext2: {
      type: String,
      required: false,
      default: null
    }
  },

  data () {
    return {
      IconHelpers
    }
  },

  computed: {
    detailItems () {
      return formatScaleDataInfo(this.scaleData, this.scaleDataSource, this.ext2)
    }
  },

  methods: {
    getScaleDataSourceIcon (scaleDataSource) {
      switch (scaleDataSource) {
        case ScaleDataSource.Scaled.value:
          return 'mdi-ruler-square'
        case ScaleDataSource.Expansion.value:
          return 'mdi-alpha-e-circle-outline'
        case ScaleDataSource.Imported.value:
          return 'mdi-file-import'
      }
    },
    getScaleDataSourceTooltip (scaleDataSource) {
      return ScaleDataSource.fromInt(scaleDataSource)
    }
  }
}
</script>
